// extracted by mini-css-extract-plugin
export var customScrollbar = "Scrollbar-module--customScrollbar--34b04";
export var customThumb = "Scrollbar-module--customThumb--2951b";
export var noScroll = "Scrollbar-module--noScroll--0a80f";
export var scrollContainer = "Scrollbar-module--scrollContainer--6da98";
export var scrollLeftButton = "Scrollbar-module--scrollLeftButton--7e54f";
export var scrollOverflow = "Scrollbar-module--scrollOverflow--e8df7";
export var scrollRightButton = "Scrollbar-module--scrollRightButton--ffdab";
export var scrollWithArrow = "Scrollbar-module--scrollWithArrow--b769a";
export var scrollWrapper = "Scrollbar-module--scrollWrapper--ace0b";